/** Presentation only. Absence/unreadable tenant flag preserves the existing page. */
export const ROSTER_SETTINGS_HUB_FLAG = 'roster_settings_hub_v1';
export function isTenantScopedRosterSettingsFlag(key: string | null | undefined): boolean {
  return key === ROSTER_SETTINGS_HUB_FLAG;
}
